import handleSpin from "../handlers/handleSpin";

export default function handleCoordinates(spin) {
  const { c0y, c1y } = handleSpin(spin);
  // curve point 0 coordinates
  this.c0coordinates(this.ball.x, this.ball.y - c0y);

  // curve point 1 coordinates
  this.c1coordinates(this.p1.x, this.p1.y - c1y);
}
